import { createTheme, responsiveFontSizes } from '@mui/material/styles';

import { Inter } from 'next/font/google';
import { intradayPaperTradeTheme } from '../utils/constants';

const interFont = Inter({ subsets: ['latin'] });

declare module '@mui/material/styles' {
  interface Palette {
    custom: any;
  }
  interface PaletteOptions {
    custom: any;
  }
}

export const lightTheme = responsiveFontSizes(
  createTheme({
    typography: {
      fontFamily: interFont.style.fontFamily,
    },
    palette: {
      mode: 'light',
      primary: {
        main: 'rgb(0,75,141)',
        dark: 'rgb(0, 35, 84)',
        light: 'rgb(109,207, 246)',
      },
      secondary: {
        main: 'rgb(237, 28, 36)',
      },
      error: {
        main: '#D01313',
      },
      custom: intradayPaperTradeTheme,
    },
  })
);
